import {initOrderPage} from "./init-order-page";
import {initPage} from "./init-page";

window.addEventListener(`load`, () => {
  initPage({policyButtonTitle: `Оформить заказ`});
  initOrderPage(shopInfoData, orderData);
});
